import { render, staticRenderFns } from "./ChangedImages.vue?vue&type=template&id=997bf2f2&"
import script from "./ChangedImages.vue?vue&type=script&lang=js&"
export * from "./ChangedImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports